import ComparePlans from './ComparePlans'
export default ComparePlans
